export default "__VITE_ASSET__D35H1kTV__"